<template>
  <carousel
    :rotate-tag="{ __eventType: 'click' }"
    :auto-rotate="false"
    :rotation-timing="rotationTiming"
    go-to-slide-text="Go to slide"
    pause-carousel-text="pause carousel"
    play-carousel-text="play carousel"
    previous-slide-text="previous slide"
    next-slide-text="next slide"
  >
    <slide v-for="(slider, index) in carouselDetails" :key="index">
      <div @click="navigateUrl(slider.navigationurl, slider.navigationurltarget, slider.title)">
        <div class="image">
          <picture>
            <source media="(max-width: 430px)" :srcset="slider.mobileimage" />
            <source media="(min-width: 431px)" :srcset="slider.desktopimage" />
            <img :alt="slider.imagetitle || 'slider-' + index" :src="slider.desktopimage" />
            <p class="disclaimer" v-html="slider.disclaimer"></p>
          </picture>
        </div>
        <div class="col-sm-12 col-md-offset-6 slide-information">
          <div v-if="slider.carouseltypeone" class="text-over-image slider-one">
            <div v-show="slider.title != ''" class="slider-image-title">
              {{ slider.title }}
            </div>
            <div v-show="slider.subtitle != ''" class="slider-image-subtitle">
              {{ slider.subtitle }}
            </div>
            <div v-show="slider.CarouselBody != ''" class="slider-image-CarouselBody">
              {{ slider.CarouselBody }}
            </div>
            <div v-show="slider.ratings != ''" class="slider-image-percent slider-rating">
              {{ slider.ratings }}
              <div class="slider-stars">
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#ff373b"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="sliderrating(slider.ratings)"
                  :star-size="30"
                  :star-points="[star]"
                  :show-rating="false"
                >
                </star-rating>
              </div>
              <div v-show="slider.percentage != ''" class="slider-image-percent">
                {{ slider.percentage }}%
              </div>
              <div v-show="slider.percentagedescription != ''" class="slider-image-description">
                {{ slider.percentagedescription }}
              </div>
            </div>
            <div v-show="slider.reviews != ''" class="slider-reviews">
              <span>&#8220;</span>{{ slider.reviews }}<span>&#8221;</span>
            </div>
            <div v-show="slider.signature != ''" class="review-signature">
              {{ slider.signature }}
            </div>
            <div v-show="slider.buttontext != ''" class="slider-image-button">
              <a
                :href="
                  navigateUrl(
                    slider.navigationurl,
                    slider.navigationurltarget,
                    slider.title,
                    'button',
                  )
                "
                role="button"
                class="btn-primary slider-button"
              >
                <strong>{{ slider.buttontext }}</strong>
              </a>
            </div>
          </div>
          <!--type2-->
          <div v-if="slider.carouseltypetwo" class="text-over-image slider-two">
            <div v-show="slider.title != ''" class="slider-image-title red">
              {{ slider.title }}
            </div>
            <div v-show="slider.subtitle != ''" class="slider-image-subtitle red">
              {{ slider.subtitle }}
            </div>
            <div v-show="slider.CarouselBody != ''" class="CarouselBody-container">
              <span class="tooltiptext" v-html="slider.CarouselBody"> </span>
              <p
                class="carouselbody-css"
                style="
                  font:
                    normal normal bold 15px/19px 'Open Sans',
                    sans-serif;
                "
                v-html="slider.CarouselBodyCss"
              ></p>
            </div>
            <div v-show="slider.ratings != ''" class="slider-image-percent slider-rating">
              {{ slider.ratings }}
              <div class="slider-stars">
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#b50012"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="sliderrating(slider.ratings)"
                  :star-size="20"
                  :star-points="[
                    23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17,
                  ]"
                  :show-rating="false"
                >
                </star-rating>
              </div>
            </div>
            <div
              v-show="slider.buttontext != ''"
              class="slider-image-button"
              :class="{
                'align-center-data-btn': slider.CarouselBody === '',
              }"
            >
              <a
                :href="
                  navigateUrl(
                    slider.navigationurl,
                    slider.navigationurltarget,
                    slider.title,
                    'button',
                  )
                "
                role="button"
                class="btn-primary slider-button"
              >
                <strong>{{ slider.buttontext }}</strong>
              </a>
            </div>
          </div>
          <!--type3-->
          <div v-if="slider.carouseltypeThree" class="text-over-image slider-three">
            <div v-show="slider.title != ''" class="slider-image-title blue">
              {{ slider.title }}
            </div>
            <div v-show="slider.subtitle != ''" class="slider-image-subtitle blue">
              {{ slider.subtitle }}
            </div>
            <div v-show="slider.CarouselBody != ''" class="CarouselBody-container">
              <span class="tooltiptext" v-html="slider.CarouselBody"> </span>
              <p
                class="carouselbody-css"
                style="
                  font:
                    normal normal bold 15px/19px 'Open Sans',
                    sans-serif;
                "
                v-html="slider.CarouselBodyCss"
              ></p>
            </div>
            <div v-show="slider.ratings != ''" class="slider-image-percent slider-rating">
              {{ slider.ratings }}
              <div class="slider-stars">
                <star-rating
                  :increment="0.01"
                  :read-only="true"
                  active-color="#0da3c4"
                  :border-width="3"
                  border-color="transparent"
                  :rounded-corners="true"
                  :rating="sliderrating(slider.ratings)"
                  :star-size="20"
                  :star-points="[
                    23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17,
                  ]"
                  :show-rating="false"
                >
                </star-rating>
              </div>
            </div>
            <div v-show="slider.buttontext != ''" class="slider-image-button">
              <a
                :href="
                  navigateUrl(
                    slider.navigationurl,
                    slider.navigationurltarget,
                    slider.title,
                    'button',
                  )
                "
                role="button"
                class="btn-primary slider-button"
              >
                <strong>{{ slider.buttontext }}</strong>
              </a>
            </div>
          </div>
          <!-- type 4 -->
          <div v-if="slider.carouseltypeFour" class="text-over-image slider-four">
            <div v-show="slider.title != ''" class="slider-image-title white">
              {{ slider.title }}
            </div>
            <div v-show="slider.subtitle != ''" class="slider-image-subtitle white">
              {{ slider.subtitle }}
            </div>
            <div v-show="slider.CarouselBody != ''" class="CarouselBody-container">
              <span class="tooltiptext" v-html="slider.CarouselBody"> </span>
              <p
                class="carouselbody-css"
                style="
                  font:
                    normal normal bold 15px/19px 'Open Sans',
                    sans-serif;
                "
                v-html="slider.CarouselBodyCss"
              ></p>
            </div>
            <div v-show="slider.buttontext != ''" class="slider-image-button">
              <a
                :href="
                  navigateUrl(
                    slider.navigationurl,
                    slider.navigationurltarget,
                    slider.title,
                    'button',
                  )
                "
                role="button"
                class="btn-primary slider-button"
              >
                <strong>{{ slider.buttontext }}</strong>
              </a>
            </div>
          </div>
        </div>
      </div>
    </slide>
  </carousel>
</template>
<script>
import StarRating from 'vue-star-rating';
export default {
  name: 'mixa-carousel-home',
  components: {
    StarRating,
  },
  props: {
    carouselDetails: {
      required: false,
      type: Array,
    },
    rotationTiming: {
      required: false,
      type: Number,
    },
  },
  data() {},
  methods: {
    sliderrating(rating) {
      let ratingValue = rating.split('/');
      return ratingValue[0];
    },
    navigateUrl(url, urlTarget, cardname, button = null) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'uaevent',
        eventCategory: 'homepage',
        eventAction: `select::slider navigation`,
        eventLabel: `${cardname}::${url}`,
        ecommerce: undefined,
        event_name: 'slider_button_click',
        cta_name: cardname,
        link_url: url,
      });
      if (button != null) {
        return url;
      } else {
        if (urlTarget == '_blank') {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      }
    },
  },
};
</script>
